import { getTrishIntroBubbles } from "~/lib/marketplace/home-trish-onboarding";

export function getPartnerIntroBubbles(input: {
  agentName: string;
  productName: string;
  welcomeIntro?: string | null;
}): string[] {
  const custom = input.welcomeIntro?.trim();
  if (custom) {
    return [custom];
  }

  const product = input.productName.trim() || "Inbound GPT";
  const base = getTrishIntroBubbles(product as "Inbound GPT");
  return base.map((line) =>
    line
      .replace(/\bTrish\b/g, input.agentName)
      .replace(/\bI'm Trish\b/gi, `I'm ${input.agentName}`),
  );
}

export function getPartnerIntroMessage(input: {
  agentName: string;
  productName: string;
  welcomeIntro?: string | null;
}): string {
  return getPartnerIntroBubbles(input).join("\n\n");
}
